import { SAGA_ACTIONS } from "../../../_config";
import { useApiCall } from "../appApiCallHook";
import { apiCaller } from "../functions";

export function useUnitsApi() {
    const callApi = useApiCall();

    return {
        searchUnit: apiCaller(callApi, SAGA_ACTIONS.UNITS.SEARCH_UNIT),
        addUpdateUnit: apiCaller(callApi, SAGA_ACTIONS.UNITS.ADD_UPDATE_UNIT),
        deleteUnit: apiCaller(callApi, SAGA_ACTIONS.UNITS.DELETE_UNIT),
        unitDetails: apiCaller(callApi, SAGA_ACTIONS.UNITS.UNIT_DETAILS),
    };
}
